import styled, { keyframes } from "styled-components";

import { media } from "../../../styles/media";

const pageEnter = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PageWrapperStyles = styled.div`
  width: calc(100% - 240px);
  margin-left: 240px;
  padding: 21px 24px;
  background: #f8f9fd;
  animation: ${pageEnter} 0.3s ease-out;

  /* Drawer layout: content takes the full width and is pushed below the fixed
     56px mobile top bar. */
  ${({ theme }) => media.maxTablet`
    width: 100%;
    margin-left: 0;
    padding: 72px 16px 16px;
    /* Safety net against stray horizontal overflow from wide children (e.g. a
       chart or grid). Using clip rather than hidden avoids promoting overflow-y
       to auto, so vertical scroll and position sticky keep working. Inner table
       scroll wrappers keep their own horizontal auto-scroll. */
    overflow-x: clip;
  `}
`;
